// services/appInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

let appInsights = null;

const isProduction = process.env.REACT_APP_ENV === 'production';

const instrumentationKey =
  process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY;

const ingestionEndpoint =
  process.env.REACT_APP_APPINSIGHTS_INGESTION_ENDPOINT;

// Initialize only when all required values exist
if (isProduction && instrumentationKey && ingestionEndpoint) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: `InstrumentationKey=${instrumentationKey};IngestionEndpoint=${ingestionEndpoint}`,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {
          history: null
        }
      }
    }
  });

  appInsights.loadAppInsights();
}


export const trackEvent = (name, properties = {}) => {
  if (appInsights) appInsights.trackEvent({ name }, properties);
};

export const trackException = (error, severityLevel = 1) => {
  if (appInsights) appInsights.trackException({ exception: error, severityLevel });
};

export const trackTrace = (message, properties = {}) => {
  if (appInsights) appInsights.trackTrace({ message }, properties);
};

export const trackPageView = (name, url) => {
  if (appInsights) appInsights.trackPageView({ name, uri: url });
};

export { appInsights, reactPlugin };
